import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import {
  newFavoriteCreated,
  favoriteRemoved
} from '../../redux/actions/favorite'
import { getFavorites, isFavorite } from '../../redux/selectors/favorite'

class Favoritable extends React.Component {
  constructor (props) {
    super(props)

    this.toggleFavorite = this.toggleFavorite.bind(this)
    this.removeFromFavorites = this.removeFromFavorites.bind(this)
    this.addToFavorites = this.addToFavorites.bind(this)
  }

  addToFavorites (callback, params) {
    this.props.planEntry.addToFavorites(params).then(res => {
      const newFavorite = res.data.planEntry.favorite
      this.props.addToFavoritesState(newFavorite)

      if (callback) callback(res.data)
    })
  }

  removeFromFavorites (callback) {
    this.props.favorites
      .filter({ planEntry: this.props.planEntry.id })
      .first()
      .removeFavorite()
      .then(res => {
        this.props.removeFavoriteFromState(res.data.id)
        if (callback) callback(res.data)
      })
  }

  toggleFavorite (callbackFunctions = {}) {
    if (this.props.isFavorite) {
      this.removeFromFavorites(callbackFunctions.removeCallback)
    } else {
      this.addToFavorites(callbackFunctions.addCallback)
    }
  }

  render () {
    const childProps = {
      toggleFavorite: this.toggleFavorite,
      addToFavorites: this.addToFavorites,
      removeFromFavorites: this.removeFromFavorites,
      isFavorited: this.props.isFavorite
    }

    return this.props.children(childProps)
  }
}

Favoritable.propTypes = {
  addToFavoritesState: PropTypes.func,
  favorites: PropTypes.object,
  planEntry: PropTypes.object,
  removeFavoriteFromState: PropTypes.func,
  isFavorite: PropTypes.bool
}

const mapStateToProps = (state, props) => {
  return {
    favorites: getFavorites(state),
    isFavorite: isFavorite(state, props.planEntry.id)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    addToFavoritesState: planEntryId => {
      dispatch(newFavoriteCreated(planEntryId))
    },
    removeFavoriteFromState: favoriteId => {
      dispatch(favoriteRemoved(favoriteId))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Favoritable)
